import React, {useState} from 'react';
import EsiaActivateCard from './esiaActivateCard';
import {LoginLayout} from '../components/layout';
import {useStyles} from '../../../shared/hooks/styles';
import {useAppDispatch} from '../../../redux';
import {LoginState} from '../../../shared/models/login/loginStep';
import {loginStepSlice} from '../../../redux/reducers/runtime/loginStep';
import {loginSlice} from '../../../redux/reducers/login';
import {Screens} from '../../../shared/routing';
import {useFocusEffect, useNavigation} from '@react-navigation/native';
import {BackHandler, Platform} from 'react-native';

export default () => {
  const dispatch = useAppDispatch();
  const navigation = useNavigation();
  const [isIssuePointSelectionVisible, setIsIssuePointSelectionVisible] = useState(false);
  const title = isIssuePointSelectionVisible ? 'Выбрать пункт выдачи' : 'Ваше заявление принято';

  const styles = useStyles(() => {
    return {
      root: {
        position: 'relative',
        paddingBottom: 20,
        overflow: 'hidden',
        margin: Platform.OS === 'ios' ? 1 : 0,
        minHeight: undefined,
      },
    };
  });

  const onBack = () => {
    dispatch(loginSlice.actions.setEsiaUserHasNoCards(false));
    dispatch(loginSlice.actions.resetEsiaFlow(null));
    dispatch(loginStepSlice.actions.setLoginStep(LoginState.enter));
    navigation.navigate(Screens.Login);
  };

  React.useEffect(() => {
    const backHandler = BackHandler.addEventListener('hardwareBackPress', () => {
      onBack();
      return true;
    });
    return () => backHandler.remove();
  }, []);

  useFocusEffect(
    React.useCallback(() => {
      if (Platform.OS !== 'ios') return undefined;
      return () => {
        dispatch(loginSlice.actions.setEsiaUserHasNoCards(false));
        dispatch(loginSlice.actions.resetEsiaFlow(null));
        dispatch(loginStepSlice.actions.setLoginStep(LoginState.enter));
        navigation.navigate(Screens.Login);
      };
    }, [dispatch, navigation]),
  );

  return (
    <LoginLayout
      title={title}
      showLogo={false}
      onBack={onBack}
      containerStyle={styles.root}
      titleStyle={{paddingBottom: 5}}>
      <EsiaActivateCard onIssuePointSelectionVisibleChange={setIsIssuePointSelectionVisible} />
    </LoginLayout>
  );
};
